module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWBAMAAADOL2zRAAAAElBMVEX////LODfKMzLPT07//Pv78fF+kAizAAAApUlEQVRo3u3WQQ7CIBBG4THivo26V04gnoBFD6D3v4xUNPGPGFywIO37kiaEmbxVFxgAAAAAAH/yLVg2tkCri5ZXhauzXAlt7U2Fearu6epmRYHWglubdL7odJuOg7Z26Xh8b9OiRYtWr60nWmtsRTP3mjptufTFmFvzlsut8vZYIP9qFa2ltaZvIU0/3uKHqcp+CqMYrIpWj62rFycDAAAAAKCVB/N4vCslrUgOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/PlaygroundSection/skills/npm.png
// module id = 288
// module chunks = 0